import React, { useState, useEffect } from 'react'
import { GetEInvoiceAddressApi } from '../services/getEInvoiceAddressApi'
import { useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import {
  GetUrunFiyatFarkiInvoiceApi,
  URUN_FIYAT_FARKI_INVOICE_SOURCE,
} from '../../Reports/VodafoneUrunFiyatFarki/services/getUrunFiyatFarkiInvoiceApi'

export default function EInvoice() {
  const [eInvoiceUrl, setEInvoiceUrl] = useState<string>("")
  const [loading, setLoading] = useState<boolean>(true)
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const qpEInvoiceId = searchParams.get('eInvoiceId')
    const qpDate = searchParams.get('date')

    if (!qpEInvoiceId || !qpDate) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Böyle E-Fatura bulunamamıştır.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
      return
    }

    // Vodafone Ürün Fiyat Farkı satış faturaları bayi kontrolü farklı olduğundan ayrı uçtan alınır.
    const api =
      searchParams.get('source') === URUN_FIYAT_FARKI_INVOICE_SOURCE
        ? new GetUrunFiyatFarkiInvoiceApi({} as any)
        : new GetEInvoiceAddressApi({} as any)

    const req = {
      InvoiceNumber: qpEInvoiceId,
      DateTime: qpDate
    }

    const fetchInvoice = async () => {
      try {
        // Şu an tipin string; backend’ten URL veya base64/… geliyor olabilir
        const res: string = await api.getEInvoiceAddress(req)

        if (!res || res === "Dosya bulunamadı.") {
          setLoading(false)
          Swal.fire({
            icon: 'error',
            title: 'Böyle E-Fatura bulunamamıştır.',
            showConfirmButton: true,
            allowOutsideClick: false,
          })
          return
        }

        // 1) Eğer hala düz URL dönüyorsa:
        if (res.startsWith('http://') || res.startsWith('https://')) {
          setEInvoiceUrl(res)
          setLoading(false)
          return
        }

        // 2) PDF base64 string gibi bir şey dönüyorsa (örnek: sadece base64 içerik)
        // "data:application/pdf;base64,..." şeklindeyse başını at
        const base64String = res.replace(/^data:application\/pdf;base64,/, '')

        const byteCharacters = atob(base64String)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })

        const blobUrl = URL.createObjectURL(blob)

        // iframe + link’te kullanacağımız URL bu
        setEInvoiceUrl(blobUrl)
      } catch (err) {
        console.error(err)
        Swal.fire({
          icon: 'error',
          title: 'E-Fatura alınırken bir hata oluştu.',
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      } finally {
        setLoading(false)
      }
    }

    fetchInvoice()
  }, [searchParams])

  if (loading) {
    return <h4 style={{ textAlign: "center" }}>Yükleniyor...</h4>
  }

  if (!eInvoiceUrl) {
    return <h4 style={{ textAlign: "center" }}>Dosya Bulunamadı</h4>
  }

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Kullanıcı tıklar → popup blocker engellemez */}
      <div style={{ textAlign: 'center', padding: '10px' }}>
        <a
          href={eInvoiceUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'underline', cursor: 'pointer' }}
        >
          E-Faturayı yeni sekmede aç
        </a>
      </div>

      {/* Sayfanın içinde gösterme */}
      <div style={{ flex: 1 }}>
        <iframe
          src={eInvoiceUrl}
          style={{ height: '100%', width: '100%', border: 'none' }}
          title="E-Fatura"
        />
      </div>
    </div>
  )
}
